/**
 * Note: Due to a conflict with `node` constants, this module must be imported like so:
 * import { VARIABLE } from 'constants/index
 */
import { FeedKey } from 'api';
import i18n from 'config/i18n';
import { INotify } from '../types/app';

export const ALL_MENTIONS_REGEX = /<#U.*?>/g;
export const SPLIT_MENTION_REGEX = /<#U(.*?)>/;
export const GROUP_FEED_KEY = FeedKey.Group;
export const USER_FEED_KEY = FeedKey.Timeline;
export const USER_FEED_NAME: string = i18n.t('components:timeline');
export const USER_FEED_ID = '0';

export const CONNECTION_SUCCESS_MESSAGE = 'connectionSuccess';
export const CONNECTION_FAILURE_MESSAGE = 'connectionFailure';

export const NO_NAME: string = i18n.t('components:unknownName');
export const DEFAULT_SORT = true;

// TypeScript helpers
export const NULL = null as null;
export const ARRAY = [] as [];

export const APP_IMAGES = {
  Invalid: '404.png',
  Logo: 'logo.png',
  ReadOnly: 'read-only.png',
  SocialLoading: 'social-loading.png',
  Welcome1: 'welcome1.png',
  Welcome2: 'welcome2.png',
};

export const TWITTER_LIMIT = 280;
export const FACEBOOK_LIMIT = 1000;
export const LINKEDIN_LIMIT = 1000;

export const FOLLOW_QUERIES_LIMIT = 25;
export const CONTENT_EMAIL_LIMIT = 10;

export const DEFAULT_NOTIFY_OPTIONS: INotify = {
  component: null,
  message: null,
  i18n: null,
  duration: 2000,
};
